module.exports = __webpack_public_path__ + "static/media/btn-right.79fc8b5f.svg";